import React, { Component, useState, Fragment } from "react";
import moment from "moment";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IntlMessages from "../../util/IntlMessages";
import Typography from "@material-ui/core/Typography";

import { Loading } from "../index";
import Status from "../Status";

import { NavLink, withRouter } from "react-router-dom";

class DataTable extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <Table>{this.props.children}</Table>;
  }
}

const DataTableHead = (props) => {
  const { columns, sort, orderBy, style } = props;
  const updateProps = (data) => {
    if (props.sort) props.sort(data);
  };
  let rightColums = ["action"];
  return (
    <TableHead>
      <TableRow>
        {columns.length > 0 &&
          columns.map((column) => {
            return (
              <TableCell
                key={column.id}
                style={style}
                align={!rightColums.includes(column.id) ? "left" : "right"}
                padding={column.disablePadding ? "none" : "default"}
                onClick={() =>
                  updateProps({
                    key: column.id,
                    order: parseInt(column.order) === 1 ? -1 : 1,
                  })
                }
              >
                {column.label}
                {orderBy === column.id &&
                  orderBy.toLowerCase() !== "action" && (
                    <TableSortLabel
                      active={true}
                      direction={column.order == 1 ? "asc" : "desc"}
                    />
                  )}
              </TableCell>
            );
          })}
      </TableRow>
    </TableHead>
  );
};
DataTableHead.defaultProps = {
  style: {},
};

const TableCellPrint = (Dkey, key, index, actions) => {
  let notDisplay = ["_id", "action"];
  let noImage = ["", null, undefined, "none"];
  switch (key.type) {
    case "tag": {
      return (
        <TableCell
          padding="none"
          align="left"
          style={key.style ? key.style : {}}
        >
          <span className={`label ${Dkey[key.id]}`}>
            {Status[Dkey[key.id]] ? (
              <IntlMessages id={`status.${Dkey[key.id]}`} />
            ) : (
              Dkey[key.id] &&
              Dkey[key.id].charAt(0).toUpperCase() + Dkey[key.id].slice(1)
            )}
          </span>
        </TableCell>
      );
      break;
    }
    case "action": {
      return (
        <TableCell
          padding="none"
          align="left"
          style={key.style ? key.style : {}}
        >
          {key.action(Dkey)}
        </TableCell>
      );
      break;
    }
    case "image": {
      return (
        <TableCell
          padding="none"
          key={index}
          align="left"
          style={key.style ? key.style : {}}
        >
          <div className="user-profile d-flex flex-row">
            <Avatar
              alt={Dkey["name"]}
              src={
                !noImage.includes(Dkey[key.image])
                  ? Dkey[key.image]
                  : require("assets/images/placeholder.jpg")
              }
              className="ml-3 user-avatar"
            />
            <div className="user-detail">
              <h5 className="user-name">{Dkey[key.id]} </h5>
            </div>
          </div>
        </TableCell>
      );
      break;
    }
    case "date": {
      let format = key.date ? key.date : "YYYY-MM-DD";
      return (
        <TableCell
          padding="none"
          align="left"
          key={index}
          style={key.style ? key.style : {}}
        >
          {moment(Dkey[key.id]).format("YYYY-MM-DD")}
        </TableCell>
      );
      break;
    }

    case "currency": {
      return (
        <TableCell
          padding="none"
          align="left"
          key={index}
          style={key.style ? key.style : {}}
        >
          ${Number(Dkey[key.id] || 0).toFixed(2)}
        </TableCell>
      );
    }
    case "number": {
      return (
        <TableCell
          padding="none"
          align="left"
          key={index}
          style={key.style ? key.style : {}}
        >
          {Number(Dkey[key.id] || 0)}
        </TableCell>
      );
    }

    default: {
      if (Array.isArray(Dkey[key.id]) || key.numeric) {
        return (
          <TableCell
            padding="none"
            align="left"
            key={index}
            style={key.style ? key.style : {}}
          >
            {Dkey[key.id] && Dkey[key.id].length > 0 ? Dkey[key.id].length : 0}
          </TableCell>
        );
      } else if (key.id === "action") {
        return (
          <TableCell padding="none" align="right" key={index}>
            <Action actions={actions} id={Dkey._id} data={Dkey} />
          </TableCell>
        );
      } else {
        return (
          <TableCell
            padding="none"
            align="left"
            key={index}
            style={key.style ? key.style : {}}
          >
            {Dkey[key.id] || "--"}
          </TableCell>
        );
      }

      break;
    }
  }
};
class DataTableBody extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      loading,
      page,
      rowsPerPage,
      data,
      column,
      actions,
      actionBtn,
      popupBtn,
    } = this.props;
    let columnNames = column
      .map((key) => {
        return key;
      })
      .filter((key) => key != "_id" && key != "action");
    let notDisplay = ["_id"];
    return (
      <TableBody>
        {loading === false &&
          data.length > 0 &&
          data.map((Dkey, index) => {
            return (
              <TableRow hover tabIndex={-1} key={Dkey._id}>
                <TableCell padding="none" align="left">
                  {++index + page * rowsPerPage}
                </TableCell>
                {column.map((key, index) => {
                  if (!notDisplay.includes(key.id)) {
                    return TableCellPrint(Dkey, key, index, actions);
                  }
                })}
                {/* {actions && (
                  <TableCell padding="none" align="right" key={index}>
                    <Action actions={actions} id={Dkey._id} />
                  </TableCell>
                )} */}
                {actionBtn && (
                  <TableCell padding="none" align="right" key={index}>
                    <NavLink to={`${actionBtn.link}${Dkey._id}`}>
                      <Button
                        className="bg-amber text-white CBmargin"
                        style={{ margin: 0, height: "24px !important" }}
                      >
                        <i className={`zmdi ${actionBtn.icon}`} />{" "}
                        {actionBtn.title}
                      </Button>
                    </NavLink>
                  </TableCell>
                )}
                {popupBtn && (
                  <TableCell padding="none" align="right" key={index}>
                    <Button
                      style={{ margin: 0, height: "24px !important" }}
                      className="bg-amber text-white CBmargin"
                      onClick={(e) => popupBtn.action(true, Dkey._id)}
                    >
                      <i
                        className={`${
                          popupBtn.icon ? popupBtn.icon : "zmdi zmdi-eye"
                        }`}
                      />
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            );
          })}

        {loading === false && data.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={column.length}>
              <IntlMessages id="common.nodata" />
            </TableCell>
          </TableRow>
        )}
        {loading === true && (
          <TableRow>
            <TableCell align="center" colSpan={column.length}>
              <Loading />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    );
  }
}

class DataTablePagination extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      count,
      page,
      rowsPerPage,
      rowsPerPageOptions,
      onChangePage,
    } = this.props;
    return (
      <TableFooter>
        <TableRow>
          <TablePagination
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={onChangePage}
            rowsPerPageOptions={rowsPerPageOptions}
          />
        </TableRow>
      </TableFooter>
    );
  }
}
class Action extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      anchorEl: undefined,
      menuState: false,
    };

    this.onOptionMenuSelect = this.onOptionMenuSelect.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
  }

  onOptionMenuSelect = (event) => {
    this.setState({ menuState: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ menuState: false });
  };

  render() {
    const { id, data, actions } = this.props;
    const { menuState, anchorEl } = this.state;

    const ICONS = {
      Delete: <DeleteForeverIcon />,
      Edit: <EditIcon />,
      View: <VisibilityIcon />,
      Pay: <MonetizationOnIcon />,
      Earning: <MonetizationOnIcon />,
    };
    return (
      <Fragment>
        <IconButton key={id} onClick={(e) => this.onOptionMenuSelect(e)}>
          <i className="zmdi zmdi-more-vert" />
        </IconButton>
        <Menu
          className="action-menu-btn"
          anchorEl={anchorEl}
          open={menuState}
          onClose={(e) => this.handleRequestClose()}
          MenuListProps={{
            style: {
              width: 85,
              paddingTop: 0,
              paddingBottom: 0,
            },
          }}
        >
          {actions &&
            actions.map((key, index) => {
              if (
                key["label"].toLowerCase() === "delete" ||
                key["action"] === "function"
              ) {
                return (
                  <MenuItem
                    key={key["label"]}
                    onClick={(e) => {
                      this.handleRequestClose();
                      key.link(id, data);
                    }}
                  >
                    <ListItemIcon>
                      {key["icon"] !== "" ? key["icon"] : ICONS[key["label"]]}
                    </ListItemIcon>
                    <Typography variant="inherit">{key["label"]}</Typography>
                  </MenuItem>
                );
              } else {
                const link = key.keyName
                  ? key.link.replace("keyName", data[key.keyName])
                  : `${key.link}/${id}`;

                return (
                  <MenuItem
                    key={key["label"]}
                    onClick={(e) => {
                      this.handleRequestClose();
                    }}
                  >
                    <NavLink to={link}>
                      <ListItemIcon>
                        {key["icon"] !== "" ? key["icon"] : ICONS[key["label"]]}
                      </ListItemIcon>
                      <Typography variant="inherit">{key["label"]}</Typography>
                    </NavLink>
                  </MenuItem>
                );
              }
            })}
        </Menu>
      </Fragment>
    );
  }
}

const ActionLink = (props) => {
  const { index, actionBtn, id } = props;
  return (
    <TableCell padding="none" align="right" key={index}>
      <NavLink to={`${actionBtn.link}${id}`}>
        <Button className="bg-amber text-white CBmargin">
          <i className={`zmdi ${actionBtn.icon}`} /> {actionBtn.title}
        </Button>
      </NavLink>
    </TableCell>
  );
};
const ActionPopup = (props) => {
  const { key, action, id, disabled, title, icon } = props;
  return (
    <TableCell padding="none" align="right" key={key}>
      <Button
        className="bg-amber text-white CBmargin"
        onClick={() => action(id)}
        disabled={disabled}
      >
        <i className={`zmdi ${icon}`} /> {title}
      </Button>
    </TableCell>
  );
};
ActionPopup.defaultProps = {
  key: Math.random(),
  disabled: false,
  title: "",
  icon: "Zmdi-delete",
};

// DataTable= withRouter(DataTable)
// DataTableHead= withRouter(DataTableHead)
// DataTableBody= withRouter(DataTableBody)
// DataTablePagination= withRouter(DataTablePagination)
export {
  DataTable,
  DataTableHead,
  DataTableBody,
  DataTablePagination,
  Action,
  ActionPopup,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  ActionLink,
  moment,
};
